import { IStyle } from '@fluentui/react';

export interface IRoseChartStyles {
  root: IStyle;
}

export interface IRoseChartClassNames {
  root: string;
}

export const roseChartStylesDefault: Partial<IRoseChartStyles> = {
  root: {
    height: '100%',
  },
};
